// footer component

const Footer = () => {
	return (
		<footer className="main-footer">
			<p>&copy; 2024 Minipay-Dapp</p>
			<p>
				Build By: <a href="https://manelisim.pages.dev">M.Mpotulo</a>
			</p>
		</footer>
	);
};

export { Footer };
